export const API_BASE_URL = 'https://devzone-api.benefitcz.cz/v1'
export const API_UPTIME_BASE_URL = 'https://devzone-api.benefitcz.cz/api'
